var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcceptedSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5013 0.75C8.39963 0.75 0.167969 9.16875 0.167969 19.5C0.167969 29.8312 8.39963 38.25 18.5013 38.25C28.603 38.25 36.8346 29.8312 36.8346 19.5C36.8346 9.16875 28.603 0.75 18.5013 0.75ZM27.2646 15.1875L16.8696 25.8187C16.613 26.0812 16.2646 26.2312 15.898 26.2312C15.5313 26.2312 15.183 26.0812 14.9263 25.8187L9.73797 20.5125C9.2063 19.9687 9.2063 19.0687 9.73797 18.525C10.2696 17.9812 11.1496 17.9812 11.6813 18.525L15.898 22.8375L25.3213 13.2C25.853 12.6562 26.733 12.6562 27.2646 13.2C27.7963 13.7437 27.7963 14.625 27.2646 15.1875Z",
    fill: "#00B6AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptedSvg);
export default __webpack_public_path__ + "static/media/acceptedSvg.faeb85d2f7321b8345aa7b2e7fc30f0b.svg";
export { ForwardRef as ReactComponent };